import React, { useMemo, useState } from 'react';
import EnhancedTab from '../../../lib/designSystem/TabSimulation';
import SettingsCertificate from './components/Certificate';
import CustomAlert from '../../../lib/designSystem/Alert';
import BankAccounts from '../../BusinessProfile/Profile/components/BankAccounts';
import SettingsCompliance from './components/Compliance';
import { RootState } from 'services/redux/store';
import { useSelector } from 'react-redux';
import AutoEnrollment from 'pages/PruffConnect/AutoEnrollment';

const Settings = () => {
  const [openAlertSuccess, setOpenAlertSuccess] = useState('');
  const [openAlertFailed, setOpenAlertFailed] = useState('');
  const auth = useSelector((state: RootState) => state.auth);
  const isAutoEnrolled = useMemo(() => auth.user?.autoEnrrolled, [auth.user]);

  const tabs = [
    {
      index: 1,
      label: 'Certificados',
      component: <SettingsCertificate />,
    },
    {
      index: 2,
      label: 'Compliance',
      component: <SettingsCompliance />,
    },
    {
      id: 3,
      label: 'Banco',
      component: isAutoEnrolled ? <BankAccounts /> : <AutoEnrollment />,
      path: 'bankAccounts',
    },
  ];

  return (
    <div>
      <EnhancedTab title="Configuración" startValue={0} tabs={tabs} />
      <CustomAlert
        open={openAlertSuccess.length}
        title="Éxito"
        text={openAlertSuccess}
        setOpen={setOpenAlertSuccess}
      />
      <CustomAlert
        open={openAlertFailed.length}
        title="Error"
        text={openAlertFailed}
        setOpen={setOpenAlertFailed}
      />
    </div>
  );
};

export default Settings;
